import { prop } from 'ramda'
import { useFilter } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import ChecklistsFilterV2 from '../../../../containers/checklists/filters/ChecklistsFilterV2'
import DateFilter from '../../../../components/filter/DateFilter'
import FullPlacesFilterV2 from '../../../../containers/places/filters/FullPlacesFilterV2'
import QuestionsFilterV2 from '../../../../containers/questions/filters/QuestionsFilterV2'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  const { t } = useTranslation('common')
  const filters = useFilter() || {}
  const checklistIds = filters.checklistIds?.map(prop('id'))

  return (
    <ScreenViewFilterBar screen="non_compliances" open={open}>
      <ChecklistsFilterV2 />
      <QuestionsFilterV2 filter={!!checklistIds && { checklistIds }} />
      <FullPlacesFilterV2 />
      <DateFilter label={t('opening')} field="insertedAt" />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
